import type { ExtraProps } from "react-markdown";
import { Button, Flex, Text, CodeBlock } from "@appsmith/wds";
import React, { useState, useCallback } from "react";

type CodeProps = React.ClassAttributes<HTMLElement> &
  React.HTMLAttributes<HTMLElement> &
  ExtraProps;

export const Code = (props: CodeProps) => {
  const { children, className } = props;
  const match = /language-(\w+)/.exec(className ?? "");
  const [copied, setCopied] = useState(false);

  const handleCopy = useCallback(() => {
    navigator.clipboard.writeText(String(children)).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    });
  }, [children]);

  return match ? (
    <div data-component="code">
      <Flex
        alignItems="center"
        justifyContent="space-between"
        padding="spacing-1"
      >
        <Text size="caption">{match[1]}</Text>
        <Button icon="copy" onPress={handleCopy} size="small" variant="ghost">
          {copied ? "Copied!" : "Copy"}
        </Button>
      </Flex>
      <CodeBlock
        PreTag="div"
        customStyle={{
          backgroundColor: "var(--color-bg-neutral-subtle)",
        }}
        language={match[1]}
      >
        {String(children).replace(/\n$/, "")}
      </CodeBlock>
    </div>
  ) : (
    <code className={className}>{children}</code>
  );
};

export { Code as code };
